import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    secondary: {
      main: '#a1008f',
    },
    lime: {
      main: '#b7c402',
    },
  }
});

export default theme;
